import { Container } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import LoadingCircular from './LoadingCircular';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  title: {
    color: theme.palette.mode === 'dark' ? '#fff' : '' ,
    fontSize: '1.44em !important',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    verticalAlign: 'sub',
    fontWeight: '500',
    lineHeight: '1.5em',
    [theme.breakpoints.down('sm')]: {
      height: '4.571em'
    },
  },
  toolbar: {
    display:'flex',
    alignItems:'center',
    padding: '0',    
  },
  appBar: {    
    [theme.breakpoints.up('sm')]: {
        margin: '16px 0'
    },
  },
}));

/**
 * AppTitleDesktop
 * 
 * @param {Object} props
 * @param {string} props.title - Titulo da página.
 * @param {boolean} [props.loading] - Flag opcional para exibir o loading.
 * @returns {JSX.Element}
 */
export default function AppTitleDesktop({ title, loading }) {
  const classes = useStyles();

  return (
    <div className={`${classes.root}`}>
      <div className={classes.appBar}>
        <Container style={{ padding: '0' }} maxWidth={'md'}>
          <div className={classes.toolbar}>
            <Typography variant="h1" className={classes.title}>
              {title}
            </Typography>
          </div>
        </Container>
        {loading && <LoadingCircular />}
      </div>
    </div>
  );
}

